import { globalEndpoints } from "../globalEndpoints";
import { mainApi } from "../mainApi";

const path = "v2/support";
const name = "Support";

export const supportApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    // basic global endpoints
    ...globalEndpoints(builder, path, name, []),

    getSupportSummary: builder.query({
      query: (params) => ({
        url: `${path}/summary`,
        method: "GET",
        params,
      }),
      providesTags: [name],
    }),
  }),
});

export const {
  useGetAllSupportQuery,
  useUpdateSupportMutation,
  useDeleteSupportMutation,
  useGetByIdSupportQuery,
  useCreateSupportMutation,
  useGetSupportSummaryQuery,
} = supportApi;
